import SettingsModule, {SettingsMenuTopCategory} from "../../../../core/modules/settings-module";
import {SettingsParentSection} from "../../const";
import {SettingsSection, SettingsSectionTitleDict} from "../../@const";

export default class PrioritiesSettingsModule extends SettingsModule {

    constructor() {
        super({
            name                     : "Priorities",
            description              : "You can customize priorities and their labels for your organization. For example, instead of the default available priorities, Low - Normal - High, you can have a more granular list, e.g. Lowest - Low - Normal - High - ASAP.",
            svgIcon                  : "isvg-priorities",
            settingsUrl              : "settings/priorities",
            settingsMenuTopCategory  : SettingsMenuTopCategory.ORGANIZATION,
            typeLabel                : SettingsSectionTitleDict[SettingsSection.TASKS_PROJECTS],
        });

        this.canDisable             = false

        this.parentSection          = SettingsParentSection.TASKS_PROJECTS
    }

}
